module.exports = __webpack_public_path__ + "assets/img/saules-moduliu-isdestymas.92179d40.webp";